"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Button_1 = require("@components/buttons/Button");
const useIPOC_1 = require("@app/routes/IPOCPage/hooks/useIPOC");
const apiFetch_1 = require("@app/utils/apiFetch");
const Apply = ({ selectedTags, t }) => {
    const [waiting, setWaiting] = (0, react_1.useState)(false);
    const handleSave = (0, react_1.useCallback)(() => {
        setWaiting(true);
        const searchParams = (0, useIPOC_1.getIPOCSearchParams)();
        (0, apiFetch_1.apiFetch)("/set_ipoc/" + searchParams, {
            method: "POST",
            body: JSON.stringify({
                exercises: selectedTags.map(({ exercise_id, group_slug }, position) => ({
                    exercise_id,
                    group_slug,
                    position,
                })),
            }),
        })
            .then((response) => response.json())
            .then(() => setWaiting(false));
    }, [selectedTags]);
    return (react_1.default.createElement(Button_1.Button, { variant: "primary", onClick: handleSave, disabled: waiting }, waiting ? t.applying : t.apply));
};
exports.default = Apply;
